import { render, staticRenderFns } from "./coverImg.vue?vue&type=template&id=c957a406&"
import script from "./coverImg.vue?vue&type=script&lang=js&"
export * from "./coverImg.vue?vue&type=script&lang=js&"
import style0 from "./coverImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports